import { render, staticRenderFns } from "./EditSellerHeader.vue?vue&type=template&id=13f71f21&scoped=true&"
import script from "./EditSellerHeader.vue?vue&type=script&lang=js&"
export * from "./EditSellerHeader.vue?vue&type=script&lang=js&"
import style0 from "./EditSellerHeader.vue?vue&type=style&index=0&id=13f71f21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f71f21",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/work/kontalk/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon,VLayout})
